<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div>
        <h5 class="info-text">
         Step 1: Select Submit then Click Next.
        </h5>
        <div class="md-layout">
          <div class="md-layout-item md-size-60 mt-4 md-small-size-100">

            <ValidationProvider
              name="reason"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>apps</md-icon>
                <label for="select">Select Action</label>
                <md-select v-model="reason" name="reason">
                  <md-option value="submitted">Submit</md-option>
                </md-select>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>

        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { extend } from 'vee-validate';

// extend("required", required);

export default {
    props: {
        avatar: {
            type: String,
            default: process.env.VUE_APP_BASE_URL + '/img/default-avatar.png'
        }
    },
    data () {
        return {
            reason: '',
        };
    },
    methods: {
        validate () {
            return this.$refs.form.validate().then(res => {
                this.$emit('on-validated', res);
                return res;
            });
        },

    }
};
</script>
<style></style>
